<template>
  <div>
    <div class="header profile" />
    <div class="container">
      <div class="box is-large gutter">
        <h1 class="title is-1">
          Checkout
        </h1>

        <div v-if="$store.getters['cart/cartCount'] > 0">
          <div
            v-for="(item, i) in $store.getters['cart/cart']"
            :key="`${i}-${item.track.pk}-${item.product.pk}`"
            class="columns is-mobile is-vcentered track"
          >
            <div
              class="column cover is-narrow is-hidden-mobile"
            >
              <img :src="item.track.cover_thumbnail">
            </div>
            <div class="column">
              <p class="text label-medium track-title">
                {{ item.track.display_title }}
              </p>
              <p class="text small track-artist">
                {{ item.track.artist.name }}
              </p>
              <p
                v-if="item.track.instrumental_version"
                class="text small"
              >
                <span
                  class="icon-static small info"
                  style="margin: -4px 0 -4px 0;"
                />
                Includes instrumental version
              </p>
              <span class="tag is-small is-hidden-tablet">{{ item.product.name }}</span>
            </div>
            <div class="column is-hidden-mobile">
              <h3 class="title is-4">
                {{ item.product.name }} Licence
              </h3>
            </div>
            <div class="column is-narrow">
              {{ item.product.amount|formattedDbAmount($store.getters['cart/currencySymbol']) }}
            </div>
          </div>
          <p
            v-if="$store.getters['cart/hasMixedCurrencies']"
            class="help is-danger"
            role="alert"
          >
            You have products with multiple currencies in your cart. Please clear your cart and start again.
          </p>
          <div class="total">
            <h3 class="title is-3 is-pulled-left">
              Amount due
            </h3>
            <span class="is-pulled-right text caption">{{ $store.getters['cart/total']|formattedDbAmount(currencySymbol) }}</span>
          </div>
        </div>

        <br>

        <form class="form">
          <div class="columns">
            <div class="column is-half">
              <h3 class="title is-3">
                Billing details
              </h3>

              <div class="field">
                <div class="control">
                  <input
                    v-model="billing_details.name"
                    class="input"
                    type="text"
                    required
                    placeholder="Cardholder name"
                  >
                </div>
              </div>

              <div class="field">
                <div :id="cardElId" />

                <p
                  v-if="cardError"
                  id="card-errors"
                  class="help is-danger"
                  role="alert"
                >
                  {{ cardError }}
                </p>
              </div>
              <figure>
                <img
                  src="@/assets/card-brands.png"
                  alt="Accepted card brands: Visa, Mastercard, American Express, Maestro."
                >
              </figure>
            </div>

            <div class="column is-half">
              <h3 class="title is-3">
                Invoice details <small class="dim">
                  [optional]
                </small>
              </h3>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Company</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        id="id_billing_company_name"
                        v-model="teamData.billing_company_name"
                        type="text"
                        name="billing_company_name"
                        class="input"
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Contact</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        id="id_billing_contact"
                        v-model="teamData.billing_contact"
                        type="text"
                        name="billing_contact"
                        class="input"
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Address 1</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        id="id_address_1"
                        v-model="teamData.address_1"
                        type="text"
                        name="address_1"
                        class="input"
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Address 2</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        id="id_address_2"
                        v-model="teamData.address_2"
                        type="text"
                        name="address_2"
                        class="input"
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">City</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        id="id_city"
                        v-model="teamData.city"
                        type="text"
                        name="city"
                        class="input"
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">County/area</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        id="id_county"
                        v-model="teamData.county"
                        type="text"
                        name="county"
                        class="input"
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Postal code</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        id="id_postal_code"
                        v-model="teamData.postal_code"
                        type="text"
                        name="postal_code"
                        class="input"
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Country</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <div class="select">
                        <select
                          v-model="teamData.country"
                        >
                          <option :value="''">
                            --------
                          </option>
                          <option
                            v-for="option in countryOptions"
                            :key="'checkout-country-' + option.value"
                            :value="option.value"
                          >
                            {{ option.display_name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="footer">
            <button
              class="button is-primary is-large is-pulled-right"
              :class="{ 'is-loading': busy }"
              :disabled="!canSubmit || busy"
              @click.prevent="handlePayClick"
            >
              Confirm &amp; Pay
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import orderClient from '@/api/orders.js'
import teamClient from '@/api/teams.js'
import { formatComponentName } from '@/utils/common.js'
import { logPaygPurchase } from '@/utils/segment.js'

const localStorageActiveOrderIdKey = 'aid'

export default {
  name: 'CartCheckout',

  data () {
    return {
      billing_details: {
        name: ''
      },
      teamData: {
        name: '', // Don't change the name in this component. Needed for API though.
        billing_company_name: '',
        billing_contact: '',
        address_1: '',
        address_2: '',
        city: '',
        county: '',
        postal_code: '',
        country: ''
      },
      countryOptions: [],
      clientSecret: null,
      orderItems: [],
      cardElId: 'card-element',
      cardElSelector: '#card-element',
      cardComplete: false,
      cardError: null,
      stripe: null,
      stripeElements: null,
      stripeCard: null,
      busy: false
    }
  },

  computed: {
    canSubmit: function () {
      return this.cardComplete && this.billing_details.name && !this.$store.getters['cart/hasMixedCurrencies']
    },

    currencySymbol: function () {
      return this.$store.getters['cart/currencySymbol']
    },

    componentName: function () {
      return formatComponentName(this)
    }
  },

  mounted () {
    this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)
    this.stripeElements = this.stripe.elements()

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    const style = {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }

    // Create an instance of the card Element.
    this.stripeCard = this.stripeElements.create('card', { style })
    this.stripeCard.on('change', (event) => {
      this.cardComplete = event.complete
    })
    this.stripeCard.mount(this.cardElSelector)

    // No way to guarantee we have the team data without loading it first.
    this.$store.dispatch('user/setMe').then(() => {
      teamClient.options()
        .then((response) => {
          this.countryOptions = response.data.actions.POST.country.choices
          this.loadTeamData()
        })
    })
  },

  methods: {
    loadTeamData: function () {
      // Load default invoice data from team profile.
      const team = Object.assign({}, this.$store.getters['user/currentTeam'])

      // Copy logged in team data to local `teamData`.
      const teamKeys = Object.keys(this.teamData)
      for (const [key, value] of Object.entries(team)) {
        if (teamKeys.includes(key)) {
          this.teamData[key] = value
        }
      }
    },

    checkLocalOrderId: function () {
      /*
       * If we have a locally stored Order ID we want to check it's for a valid order.
       */
      const vm = this
      const orderId = localStorage.getItem(localStorageActiveOrderIdKey)

      if (!orderId) {
        // Bail ... in an async friendly way.
        return new Promise(function (resolve, reject) {
          resolve()
        })
      }

      return orderClient.retrieve(orderId)
        .then((response) => {
          const order = response.data
          if (order.status === 'complete') {
            localStorage.removeItem(localStorageActiveOrderIdKey)
          } else {
            vm.orderItems = order.items
            vm.clientSecret = order.payment_intent_client_secret
          }
        })
        .catch(() => {
          // Invalid order ID - wipe from local storage so we don't use it again.
          localStorage.removeItem(localStorageActiveOrderIdKey)
        })
    },

    createOrUpdateOrder: function () {
      const vm = this
      const orderData = vm.$store.getters['cart/cartItemsToOrder']

      return this.checkLocalOrderId()
        .then(() => {
          if (!vm.clientSecret) {
            // Create order mode
            return orderClient.create(orderData)
              .then((response) => {
                vm.orderItems = response.data.items
                vm.clientSecret = response.data.payment_intent_client_secret
                localStorage.setItem(localStorageActiveOrderIdKey, response.data.pk)
                return response.data
              })
          } else {
            // Update existing order mode
            return orderClient.partialUpdate(
              localStorage.getItem(localStorageActiveOrderIdKey),
              orderData
            )
              .then((response) => {
                return response.data
              })
          }
        })
    },

    handlePayClick: function () {
      const vm = this
      const user = this.$store.getters['user/currentUser']
      let order = null
      // What to tell the user if the current step fails.
      let errorMessage = 'There was a problem saving your invoice details. Please check them and try again.'
      let isCardError = false
      let paid = false

      vm.cardError = null
      vm.busy = true

      teamClient
        .partialUpdate({ team: this.teamData, user })
        .then(() => {
          errorMessage = 'There was an error processing this order.'
          return vm.createOrUpdateOrder()
        })
        .then((savedOrder) => {
          order = savedOrder
          errorMessage = 'Something went wrong taking payment. Please try again.'
          return vm.stripe.confirmCardPayment(
            vm.clientSecret,
            {
              payment_method: {
                card: vm.stripeCard,
                billing_details: vm.billing_details
              }
            }
          )
        })
        .then((response) => {
          // Stripe resolves with either an error or a paymentIntent.
          if (response.error) {
            errorMessage = response.error.message
            isCardError = true
            throw response.error
          }

          // The card has been charged. The payment_intent.succeeded webhook completes the
          // order even if finalizing fails here, so from now on don't invite another payment.
          paid = true
          errorMessage = 'Your payment was successful but we couldn\'t load your licenses yet. They will appear on your licenses page shortly, so please don\'t pay again.'

          // Activate/finalize the order so we get the licenses right away.
          return orderClient.finalize(order.pk, {
            payment_intent: response.paymentIntent.id
          })
        })
        .then((response) => {
          localStorage.removeItem(localStorageActiveOrderIdKey)
          vm.$store.dispatch('cart/clearCart')

          // Need to use order data to log purchases with analytics.
          const order = response.data
          order.items.forEach(function (item) {
            const grossAmount = item.unit_amount / 100.0
            const product = vm.$store.getters['cart/getProductFromPk'](item.product)
            logPaygPurchase(grossAmount, order.currency.code, product.name)
          })

          vm.busy = false
          vm.$router.push({
            name: 'license-list',
            params: {
              showCheckoutSuccess: true,
              tracksPurchased: vm.orderItems.length
            }
          })
        })
        .catch((error) => {
          vm.cardError = errorMessage
          vm.busy = false
          if (paid) {
            localStorage.removeItem(localStorageActiveOrderIdKey)
            vm.$store.dispatch('cart/clearCart')
          }
          // Declined cards etc. are expected; anything else should reach Sentry.
          if (!isCardError) {
            return Promise.reject(error)
          }
        })
    }
  },

  metaInfo: {
    title: 'Checkout'
  }
}
</script>

<style scoped lang="scss">
  .total {
    clear: both;
    overflow: hidden;
  }

  .StripeElement {
    box-sizing: border-box;

    height: 40px;

    padding: 10px 12px;

    border: 1px solid transparent;
    border-radius: 4px;
    background-color: white;

    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
  }

  .StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
  }

  .StripeElement--invalid {
    border-color: #fa755a;
  }

  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }
</style>
